import { render } from "./add-quotations.vue?vue&type=template&id=0cd5be78"
import script from "./add-quotations.vue?vue&type=script&lang=js"
export * from "./add-quotations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__